var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login callback"},[_c('p',{staticClass:"callback__text"},[_vm._v("\n    "+_vm._s(_vm.$t('active-directory.redirecting'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }